import { SectionWrapper } from 'Components/Section/SectionWrapper'
import styled from 'styled-components'

export const AmbassadorSection = styled(SectionWrapper)`
  padding: 40px;
  margin-bottom: 20px;
  position: relative;
  &.no-padding {
    padding: 0;
    .not-found {
      padding: 0 40px 40px 40px;
    }
  }
  &.overflow-auto {
    overflow: auto;
  }

  /* COMMON */
  .padding-row {
    padding: 40px 40px 0 40px;
  }

  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }

  .row-flex {
    display: flex;
  }
  .ambassador-details-col {
    margin-bottom: 16px;
  }

  .col-title {
    color: ${props => props.theme.colors.regentGray};
    margin-bottom: 7px;
    font-size: 14px;
  }

  .col-rating {
    display: block;
    min-width: 80px;
  }

  .email {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 25px;
  }

  .stretch {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .buttons {
    margin: 30px 0;
    button + button {
      margin-left: 16px;
    }
  }

  h1 {
    margin-bottom: 40px;
  }

  h2 {
    margin-bottom: 30px;
    float: left;
    clear: both;
  }

  /* SECTIONS */
  &.statistics {
    .row {
      > div {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
          clear: both;
        }
      }
    }
  }

  .profile-picture {
    max-width: 120px;
    display: block;
  }

  .add-rating {
    position: relative;
    margin-top: 10px;
    display: inline-block;
    padding-left: 20px;
    color: ${props => props.theme.colors.primary};

    span {
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
    }
  }

  .link-edit,
  .link-delete {
    display: inline-block;
    svg {
      fill: ${props => props.theme.colors.regentGray};
    }
  }

  .link-edit {
    svg {
      left: 40px;
    }
  }

  .link-delete {
    svg {
      left: 80px;
    }
  }

  .rating {
    margin-top: 11px;

    .stars {
      display: inline-block;
      vertical-align: baseline;
      margin-right: 7px;
      svg {
        position: relative;
      }
    }
    .total {
      display: inline-block;
      vertical-align: bottom;
      font-size: 16px;
    }
  }

  .merchandise-filter {
    float: right;

    .form-select {
      width: 180px !important;
    }

    svg {
      position: absolute;
      width: 13px;
      height: 100%;
      right: 20px;
      left: initial;
      top: initial;
      z-index: ${props => props.theme.zIndexes.mainContentWrapper.first};
      transform: rotate(90deg);
      fill: ${props => props.theme.colors.secondary};
      pointer-events: none;
    }

    label {
      margin-right: 10px;
      margin-bottom: 0;
      font-size: ${props => props.theme.fontSizes.commonText};
    }
  }

  table {
    margin-bottom: 40px;
    thead {
      .fitWidth {
        width: 1%;
        white-space: nowrap;
      }
      th {
        padding: 0 30px;
      }
    }
    tr {
      td {
        position: relative;
        padding: 0 30px;
      }
      &:last-child {
        td {
          margin-bottom: 40px;
        }
      }
    }
    .pick-up-th {
      padding-right: 5rem;
    }
    .actions {
      padding-right: 75px;
    }
  }
  .signed-documents-table {
    margin-left: -65px;
    margin-right: -40px;
  }
  .activity-table {
    margin-left: -65px;
    margin-right: -40px;
  }

  .pick-up,
  .drop-off {
    position: absolute;
    left: initial;
    width: 23px;
    margin: auto;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);

    input {
      left: 0;
    }
    svg {
      top: 50%;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/City/Page/Ambassador/AmbassadorSection/index.js